import type { FC } from "react";

import { cn, makeBreakpointClassName } from "@/ui/lib/utils";
import {
  TEXT_HERO_DEFAULTS,
  TTextHeroProps,
} from "@/ui/components/typography/TextHero/TextHero.config";
import {
  TYPOGRAPHY_COLORS_CLASS_MAP,
  TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP,
  TYPOGRAPHY_WHITESPACES_CLASS_MAP,
} from "@/ui/components/typography/typography.config";

export const TextHero: FC<TTextHeroProps> = (
  {
    tag: Tag = TEXT_HERO_DEFAULTS.tag,
    color = TEXT_HERO_DEFAULTS.color,
    align = TEXT_HERO_DEFAULTS.align,
    whitespace = TEXT_HERO_DEFAULTS.whitespace,
    isResponsive = TEXT_HERO_DEFAULTS.isResponsive,
    children,
    className,
    ...props
  },
) => (
  <Tag
    {...props}
    data-component="TextHero"
    className={cn(
      "font-bold",
      "tracking-sys-tight leading-sys-0-9",
      "font-sys-display",
      makeBreakpointClassName(align, TYPOGRAPHY_RESPONSIVE_ALIGNMENTS_CLASS_MAP, "left"),
      TYPOGRAPHY_COLORS_CLASS_MAP[color],
      TYPOGRAPHY_WHITESPACES_CLASS_MAP[whitespace],
      isResponsive ? "text-sys-7xl xl:text-sys-9xl" : "text-sys-7xl",
      className,
    )
    }
  >
    { children }
  </Tag>
);

TextHero.displayName = "TextHero";
